/* src/app/warehousing/pages/report-batch-traceability/report-batch-traceability.component.scss */
/*# sourceMappingURL=report-batch-traceability.component.css.map */
